import {PropsWithChildren} from "react";
import {cn} from "@/lib/utils.ts";
import {useExtensionEditDrawer} from "@/pages/extensions/components/ProviderExtensionEdit.tsx";

export function Wrapper(props: PropsWithChildren) {

    const {isOpen} = useExtensionEditDrawer();

    return (
        <div className={cn('transition-all', isOpen && 'me-[468px]')}>
            <div className={cn("relative font-normal px-9 py-9 space-y-6 max-w-[1350px] w-full mx-auto")}>
                {props.children}
            </div>
        </div>
    )
}